export const core = {
    state: {
        savingStatus: false,
        loader: false,
        errorMsg: false
    },
    mutations: {
        'SET_SAVING_STATUS' (state, savingStatus) {
            state.savingStatus = savingStatus
        },
        SET_LOADER(state,loader) {
            state.loader = loader
        },
        SET_ERROR(state,errorMsg) {
            state.errorMsg = errorMsg
        }
    },
    actions: {
        setSavingStatus ({commit} , savingStatus) {
            commit('SET_SAVING_STATUS', savingStatus)
        },
        setLoader({commit},loader) {
            commit('SET_LOADER', loader)
        },
        setErrorMessage ({commit},errorMsg) {
            commit('SET_ERROR', errorMsg)
        }
    }
}
